import { useEffect, useMemo } from 'react';
import { Comment } from 'jamespot-front-business';
import socket from '../utils/socket';
import { useAppDispatch } from '../redux/store';

const useCommentsLikeRT = (idComments: number[] | undefined, idArticle: number) => {
    const dispatch = useAppDispatch();
    const reactSocket = useMemo(() => socket, []);
    const rtHandlers = useMemo(
        () => Comment.getCommentsLikeRTHandlers(dispatch, idComments, idArticle),
        [dispatch, idComments, idArticle],
    );

    useEffect(() => {
        rtHandlers.forEach((handler) => {
            reactSocket.onMessage(handler.namespace, handler.function, handler.handler);
        });
        return () => {
            rtHandlers.forEach((handler) => {
                reactSocket.offMessage(handler.namespace, handler.function, handler.handler);
            });
        };
    }, [rtHandlers, reactSocket]);
};

export default useCommentsLikeRT;
